// extracted by mini-css-extract-plugin
module.exports = {"isExtended":"extendedRequest_isExtended__TDvb2","title":"extendedRequest_title__5HF0t","message":"extendedRequest_message__3Ih0m","icon":"extendedRequest_icon__2XM2A"};